export default "__VITE_ASSET__BiFABzFL__"